module.exports = __webpack_public_path__ + "static/media/YF92_5.d254633a.jpg";